import { styled, css, Box, CircularProgress } from '@mui/material'
import Grid from '../Grid'
import ItemList from '../ItemList'
import Text from '../Text'
import ViewObserver from '../ViewObserver'

export const CatalogueListWrapper = styled(Grid)(() => css``)
CatalogueListWrapper.defaultProps = {
  gap: 12
}

export const CatalogueItemList = styled(ItemList)(() => css``)

export const CatalogCategorySpinner = styled(CircularProgress)(
  () => css`
    display: block;
    margin-right: auto;
    margin-left: auto;
    margin-top: 16px;
  `
)

export const LoadingCategoryText = styled(Text)(
  () =>
    css`
      margin-top: 16px;
    `
)
LoadingCategoryText.defaultProps = {
  align: 'center'
}

export const CatalogueDefault = styled(Box)(
  () => css`
    position: absolute;
    top: 0;
  `
)

export const CatalogueListObserver = styled(ViewObserver)(() => css``)
CatalogueListObserver.defaultProps = {
  offset: 20
}
